import type { Infer } from 'superstruct';
import {
	nullable,
	number,
	object,
	optional,
	refine,
	string,
} from 'superstruct';

import {
	parsableInteger,
	stringDate,
	stringMaxLength,
	userStringWithMaxLength,
} from '@adflow/shared/util-superstruct';

export const SITELINK_MAX_COUNT = 8;
export const SITELINK_LINK_TEXT_MAX_LENGTH = 25;
export const SITELINK_DESCRIPTION_MAX_LENGTH = 35;
export const SITELINK_FINAL_URL_MAX_LENGTH = 2048;

const OptionalSitelinkDescription = optional(
	nullable(stringMaxLength(SITELINK_DESCRIPTION_MAX_LENGTH))
);

export const ViewGoogleAdsSitelinkDto = object({
	id: number(),
	linkText: string(),
	finalUrl: string(),
	description1: optional(nullable(string())),
	description2: optional(nullable(string())),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

const BaseAddGoogleAdsSitelinkDto = object({
	id: optional(parsableInteger()),
	linkText: userStringWithMaxLength(SITELINK_LINK_TEXT_MAX_LENGTH),
	finalUrl: userStringWithMaxLength(SITELINK_FINAL_URL_MAX_LENGTH),
	description1: OptionalSitelinkDescription,
	description2: OptionalSitelinkDescription,
});

export const AddGoogleAdsSitelinkDto = refine(
	BaseAddGoogleAdsSitelinkDto,
	'pairedDescriptions',
	(value) => {
		const hasDescription1 =
			typeof value.description1 === 'string' && value.description1.length > 0;
		const hasDescription2 =
			typeof value.description2 === 'string' && value.description2.length > 0;

		return (
			hasDescription1 === hasDescription2 ||
			'validations:Sitelink Descriptions Error'
		);
	}
);

export type ViewGoogleAdsSitelinkDto = Infer<typeof ViewGoogleAdsSitelinkDto>;
export type AddGoogleAdsSitelinkDto = Infer<typeof AddGoogleAdsSitelinkDto>;
